export type TalkLang = "es" | "en";

type Props = {
  value: TalkLang;
  onChange: (next: TalkLang) => void;
  ariaLabel: string;
};

export default function TalkLangPills({ value, onChange, ariaLabel }: Props) {
  return (
    <div className="lang-pick" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        data-active={value === "es"}
        aria-pressed={value === "es"}
        onClick={() => onChange("es")}
      >
        Español
      </button>
      <button
        type="button"
        data-active={value === "en"}
        aria-pressed={value === "en"}
        onClick={() => onChange("en")}
      >
        English
      </button>
    </div>
  );
}